var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"preloader"},[_c('span',{staticClass:"preloader__item preloader__item--1"}),_vm._v(" "),_c('span',{staticClass:"preloader__item preloader__item--2"}),_vm._v(" "),_c('span',{staticClass:"preloader__item preloader__item--3"}),_vm._v(" "),_c('span',{staticClass:"preloader__item preloader__item--4"})]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc1fdfc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preloader.vue
// module id = null
// module chunks = 